const MAX_IMAGE_BYTES = 20 * 1024 * 1024;

const ALLOWED_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/tiff',
]);

export const ITEM_IMAGE_ACCEPT = 'image/jpeg,image/png,image/gif,image/tiff';

export type ItemImageValidationResult =
  | { valid: true }
  | { valid: false; message: string };

export const validateItemImageFile = (file: File): ItemImageValidationResult => {
  if (!ALLOWED_IMAGE_TYPES.has(file.type)) {
    return {
      valid: false,
      message: 'Image must be JPEG, PNG, GIF, or TIFF.',
    };
  }

  if (file.size > MAX_IMAGE_BYTES) {
    return {
      valid: false,
      message: 'Image must be 20 MB or smaller.',
    };
  }

  return { valid: true };
};
